import React from 'react';

export default function StatCard({ label, value, icon, borderColor, onClick, subValue }) {
  return (
    <div
      onClick={onClick}
      style={{
        backgroundColor: 'var(--card-bg)',
        borderLeft: `3px solid ${borderColor}`,
        borderRadius: '4px',
        padding: '0.75rem 1rem',
        minWidth: '140px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s'
      }}
    >
      <div style={{ fontSize: '18px', fontWeight: '700', color: borderColor }}>
        {value}
      </div>
      <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{icon} {label}</div>
      {subValue && (
        <div style={{ fontSize: '11px', color: 'var(--text-secondary)', marginTop: '2px', fontWeight: 500 }}>
          {subValue}
        </div>
      )}
    </div>
  );
}
